;(async () => {
  const storeModuleURL = window.__GLOBAL__.assets.store
  const module = await import(storeModuleURL)
  const store = module.default

  class CartDrawer extends HTMLElement {
    constructor() {
      super()

      store.events.subscribe('cartVisibleChange', this.toggle.bind(this))

      this.toggleButtons = document.querySelectorAll(
        '[data-close], [data-cart-drawer-toggle]'
      )
      this.wrapper = this.querySelector('[data-wrapper]')

      this.toggleButtons.forEach((button) => {
        button.addEventListener('click', this.toggleHandler.bind(this))
      })
    }

    toggle() {
      const isOpen = store.state.cartVisible

      this.classList.toggle('is-visible', isOpen)
      this.ariaHidden = !isOpen

      toggleBodyLock(this.wrapper, isOpen)

      if (isOpen) {
        if(document.querySelector('#gorgias-chat-container')){
        document.querySelector('#gorgias-chat-container').style.display = "none";
         document.querySelector("body").classList.remove("popup-active"); 
          dataLayer.push({'event': 'cart_drawer_open'});
        }
        this.focus()
        trapFocus(this)
        var min_height = 0;
            document.querySelectorAll('nosto-recommendation-item[data-minicart="true"]').forEach((recItem) => {
              if(recItem.querySelector('.card-information__wrapper__main') != null){
               var height = recItem.querySelector('.card-information__wrapper__main').offsetHeight;
                if(height > min_height){
                  min_height = height;
                }
              }
            });
            document.querySelectorAll('nosto-recommendation-item[data-minicart="true"]').forEach((recItem) => {
               recItem.querySelector('.card-information__wrapper__main').style.minHeight = min_height + 'px';
            });
      } else {
        if(document.querySelector('#gorgias-chat-container')){
        document.querySelector('#gorgias-chat-container').style.display = "block";
        }
      }
    }

    toggleHandler(event) {
      event.preventDefault()

      store.dispatch('cartVisible', !store.state.cartVisible)
    }
  }

  customElements.define('cart-drawer', CartDrawer)
})()